import $ from 'jquery'
import _ from 'lodash'
import SingleColumnStack from './single-column-stack'
import reportConstants, { labeledValue } from 'scoreboard/reports/report-constants'
import i18n from 'scoreboard/components/i18n'

class GroupedSingleColumnStack extends SingleColumnStack {

	constructor(index, columnAttributes, opts = {}) {
		super(index, columnAttributes, opts)
		this.grouped = true
		this.columnAttributes = columnAttributes
	}

	select(state = null, targetCell, targetDomNode, opts = {}) {
		let selected = super.select(state, targetCell, opts)

		//find the closest tbody so we can set the primary class
		if (targetDomNode) {
			this.primaryRow = $(targetDomNode).closest('tr')
		}
		if (this.primaryRow) {
			this.primaryRow.toggleClass('primary', selected)
		}

		return selected
	}

	formatValueForHeader(grouping, reportModel) {
		const data = {
			//this shim is awkward but refactoring this to unify the non-grouped
			//and grouping columns would be a big undertaking (For #42604)
			onHover: this._headerCell.onHover.bind(this._headerCell),
			//allow hover tooltips on grouped columns
			style: {
				'hover-tooltip': true
			}
		}

		let html
		if (grouping.emptyResults) {
			//#38632 show "No X" when no results on the group
			html = i18n.get('report.designer.emptyResults.noPlaceholder', this.columnAttributes.label)
		} else {
			const value = this.dataExtractor.formatForGroupHeader(grouping,
				this.columnAttributes) || ''
			let displayValue = `${value}`
			if (_.isObject(value)) {
				displayValue = value.html || ''
			}
			if (_.isEmpty(displayValue)) {
				displayValue = reportConstants.formatForBlankLabel(data).html
			}

			//#39311 if the label is blank, skip the colon separator and just output the value
			let label = _.escape(i18n.get(this.columnAttributes.label))

			displayValue = this.dataExtractor.wrapGroupHeaderValue(displayValue,
				this.columnAttributes)

			html = labeledValue(displayValue, label, {
				maxLabelLength: this.columnAttributes.calculated ?
					reportConstants.DEFAULT_LABEL_ELLIPSIS_THRESHOLD : null
			})
		}
		data.html = html
		return data
	}

	resetHeaderDomNodes() {
		const headerCell = this.headerCell()
		if (headerCell) headerCell.resetDomNodes()
	}

}


export default GroupedSingleColumnStack
GroupedSingleColumnStack.__filename__ = 'reports/common/table/grouped-single-column-stack.js'
